var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClockIco(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0C12.4187 0 16 3.58125 16 8C16 12.4187 12.4187 16 8 16C6.30312 16 4.725 15.4688 3.42812 14.5656C2.975 14.2219 2.86375 13.625 3.18125 13.1719C3.49688 12.7188 4.11875 12.6094 4.57188 12.925C5.54375 13.6031 6.725 14 8 14C11.3125 14 14 11.3125 14 8C14 4.65938 11.3125 2 8 2C6.31563 2 4.84375 2.67062 3.75625 3.75625L4.71875 4.71875C5.19063 5.19063 4.85625 6 4.19063 6H0.75C0.335938 6 0 5.66563 0 5.25V1.81062C0 1.1425 0.807813 0.807813 1.28031 1.28031L2.34313 2.34313C3.79063 0.896563 5.79063 0 7.97188 0H8ZM8 4C8.41562 4 8.75 4.33437 8.75 4.75V7.69063L10.7531 9.71875C11.0719 10.0125 11.0719 10.4875 10.7531 10.7531C10.4875 11.0719 10.0125 11.0719 9.71875 10.7531L7.46875 8.50313C7.32812 8.39062 7.25 8.2 7.25 8V4.75C7.25 4.33437 7.58437 4 8 4Z",
    fill: "#343434"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockIco);
export default __webpack_public_path__ + "static/media/clock_ico.3efad0a0028f77b6f9818e50d4a1dc4a.svg";
export { ForwardRef as ReactComponent };